import { observer } from 'mobx-react';
import { FC } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { localeStore } from 'src/mobx/localesStore';
import DonationImage from 'src/view/components/DonationImage/DonationImage';
import './style.scss';

const ProductDonation: FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.product?.is_donation) return null;

  return (
    <div className="d-flex flex-row mb-4 gap-15">
      <DonationImage imageWrapperClassName="product__donation" />
      <p className="text-size-14">{localeStore.t('itemview_donation_info')}</p>
    </div>
  );
});

export default ProductDonation;
